













import { Component, Vue } from 'vue-property-decorator';
import { getNewsDetail } from "@/req/homes";

@Component({
  components: {}
})
export default class Home extends Vue {
  public news = {
    title: '',
    created_at: '',
    content: ''
  }
  /**
   * initDetail
   * 获取详情
   */
  public initDetail() {
    const params = {
      id: this.$route.query.id
    }
    getNewsDetail(params).then(res => {
      this.news = res.data;
    })
  }
  public download() {
    this.$router.push({
      path: '/engineDownload',
      query: { tab: '2' },
    })
  }
  public mounted() {
    this.initDetail()
  }
}
